module.exports = __webpack_public_path__ + "static/media/ringtone.3ead4315.mp3";